import { render, staticRenderFns } from "./Zitate.vue?vue&type=template&id=512ec6ba&scoped=true&"
import script from "./Zitate.vue?vue&type=script&lang=js&"
export * from "./Zitate.vue?vue&type=script&lang=js&"
import style0 from "./Zitate.vue?vue&type=style&index=0&id=512ec6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ec6ba",
  null
  
)

export default component.exports